import { render } from "./RoleCreateEditDialog.vue?vue&type=template&id=347676b2&scoped=true&ts=true"
import script from "./RoleCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./RoleCreateEditDialog.vue?vue&type=script&lang=ts"

import "./RoleCreateEditDialog.vue?vue&type=style&index=0&id=347676b2&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347676b2"]])

export default __exports__